import React from 'react';
import { CheckCircle2 } from 'lucide-react';

const WhyTraainTechnology = () => {
  const benefits = [
    'Structured instead of scattered',
    'Practical instead of passive',
    'Consistent without being rigid'
  ];

  return (
    <section className="py-24 px-6 bg-gradient-to-b from-transparent to-blue-950/20">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-white">
            Traain Brings Clarity to
            <br />
            <span className="text-cyan-400">Scaled Enablement</span>
          </h2>
          <p className="text-xl text-gray-300 max-w-4xl mx-auto">
            Traain helps technology platforms and cloud marketplaces turn knowledge into measurable readiness—across partners, vendors, and internal teams.
          </p>
        </div>

        <div className="max-w-4xl mx-auto mb-12">
          <p className="text-xl font-bold text-white mb-6 text-center">With Navigator AI, training becomes:</p>
          <div className="grid md:grid-cols-3 gap-4">
            {benefits.map((benefit, index) => (
              <div
                key={index}
                className="flex items-start gap-4 p-6 rounded-xl bg-gradient-to-br from-gray-900/80 to-blue-900/20 border border-cyan-500/30 hover:border-cyan-400/60 transition-all duration-300"
              >
                <CheckCircle2 className="w-6 h-6 text-cyan-400 flex-shrink-0 mt-1" />
                <p className="text-lg text-gray-300">{benefit}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="text-center">
          <div className="inline-block p-8 rounded-2xl bg-gradient-to-br from-cyan-900/20 to-blue-900/30 border border-cyan-500/30">
            <p className="text-2xl font-bold text-white mb-2">
              So your ecosystem moves faster—together.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyTraainTechnology;
